import ModelService from "./abstract/ModelService";
import Vehicle from "../models/Vehicle";

export default class VehicleService extends ModelService {
  constructor() {
    super('/vehicles', Vehicle);
  }

  searchByLicensePlate(countryCode, licensePlate) {
    return new Promise((resolve, reject) => {
      this.get(env.API_URL + this.modelPath + '/license-plate/' + licensePlate + `?country_code=${countryCode}`).then(data => {
        resolve(data);
      }).catch(reject);
    });
  }

  getAvailabilityChanges(vehicleIds, timestamp = null) {

    if (!timestamp) timestamp = Math.floor((new Date).getTime() / 1000);

    return new Promise((resolve, reject) => {
      this.post(env.API_URL + this.modelPath + '/availability-changes', {
        timestamp: timestamp,
        vehicle_ids: vehicleIds
      }).then(data => {
        resolve(data);
      }).catch(reject);
    });
  }
}
